var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from '../../../pages/modules/base-entity';
import { autoinject, BindingEngine, transient } from 'aurelia-framework';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { Router } from 'aurelia-router';
import { NotificationClientService, NotificationType } from '../../../../services/basics/notification-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { EntityTypes } from '../../../../models/basics/basics.models';
import { RouterConstants } from '../../../../configuration/router.constants';
import { StepEnum, InstantGamesHostingTypesEnum } from '../../../../models/modules/lotteryplatofrm.models';
import { InstantGameClientService } from '../../../../services/modules/instant-game-client.service';
import { I18N } from 'aurelia-i18n';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { ValidationRules, ValidationControllerFactory, validateTrigger } from "aurelia-validation";
import * as Enumerable from 'linq';
import { Guid } from '../../../../utilities/guid';
import { InstantGameBasicMeta } from './steps/instant-game-basic-meta';
import { InstantGameTicketPrices } from './steps/instant-game-ticket-prices';
import { InstantGamePriceTiers } from './steps/instant-game-price-tiers';
import { InstantGameTicketDiscounts } from './steps/instant-game-ticket-discounts';
import { InstantGameChangeLog } from './steps/instant-game-changelog';
import { InstantGameTicketLines } from './steps/instant-game-ticket-lines';
import { InstantGameTickets } from './steps/instant-game-tickets';
import { BrandClientService } from '../../../../services/modules/brand-client.service';
import { UserClaimsService } from '../../../../services/authentication/user-claims.service';
import { BaseClaims } from '../../../../constants/authentication/base-claims';
import { DialogServiceConstants } from '../../../../constants/basics/dialog.constants';
var InstantGame = /** @class */ (function (_super) {
    __extends(InstantGame, _super);
    function InstantGame(validationControllerFactory, dialogClientService, tokenClient, router, bindingEngine, notificationService, eventAggregator, instantGameClientService, i18N, instantGameBasicMeta, instantGamePriceTiers, userClaimsService, instantGameTicketPrices, instantGameTicketDiscounts, instantGameChangeLog, brandClientService, instantGameTicketLines, instantGameTickets) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.tokenClient = tokenClient;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.instantGameClientService = instantGameClientService;
        _this.instantGameBasicMeta = instantGameBasicMeta;
        _this.instantGamePriceTiers = instantGamePriceTiers;
        _this.userClaimsService = userClaimsService;
        _this.instantGameTicketPrices = instantGameTicketPrices;
        _this.instantGameTicketDiscounts = instantGameTicketDiscounts;
        _this.instantGameChangeLog = instantGameChangeLog;
        _this.brandClientService = brandClientService;
        _this.instantGameTicketLines = instantGameTicketLines;
        _this.instantGameTickets = instantGameTickets;
        _this.activityLogEntitiesSave = [EntityTypes.InstantGame];
        _this.controller = null;
        _this.controller = validationControllerFactory.createForCurrentScope();
        _this.controller.validateTrigger = validateTrigger.changeOrBlur;
        return _this;
    }
    Object.defineProperty(InstantGame.prototype, "defaultInstantGame", {
        get: function () {
            return {
                instantGameId: 0,
                name: null,
                rngUrl: null,
                guid: Guid.generateGuid(),
                isActive: true,
                isDefault: false,
                sequenceNumber: 0,
                currencyId: 0,
                insurerId: 0,
                createdDate: new Date(),
                gameType: 0,
                notes: null,
                insuranceCostInEuro: null,
                pricingModels: [],
                instantGamePriceTiers: [],
                instantGameTypeId: 0,
                entityType: EntityTypes.InstantGame,
                identifier: Guid.generateGuid(),
                playportUrl: null,
                displayAsPortrait: false,
                gameIdentifier: "",
                externalGameId: null,
                instantGamesHostingTypeId: null,
                isWinningRangeRequired: true
            };
        },
        enumerable: false,
        configurable: true
    });
    InstantGame.prototype.attached = function () {
        var _this = this;
        var options = this.getOptions();
        if (options) {
            this.brandClientService.getBrandCurrencies({ brandId: options.brandId }).then(function (response) {
                _this._brandCurrencies = response.brandCurrencies;
            }).catch(function () { });
        }
        if (!this.item.instantGameId || !this.item.gameIdentifier) {
            setTimeout(function () {
                _this.item.gameIdentifier = Guid.generateGuid();
            });
        }
        return _super.prototype.attached.call(this);
    };
    InstantGame.prototype.initializeItemOverride = function (newItem) {
        if (newItem) {
            var options = this.getOptions();
            newItem.brandId = options != null ? options.brandId : null;
            newItem.createdDate = new Date();
            this.setNavigationInfo(newItem);
            this.initValidations(newItem);
        }
    };
    InstantGame.prototype.initializeItemOverrideForUpdate = function (newItem) {
        if (newItem) {
            var options = this.getOptions();
            newItem.brandId = options != null ? options.brandId : null;
            newItem.createdDate = new Date();
            this.setNavigationInfo(newItem);
            this.initValidations(newItem);
        }
    };
    InstantGame.prototype.getOptions = function () {
        var key = "instant_game_navigation_info";
        var options;
        if (this._navigationInstruction && this._navigationInstruction.settings && this._navigationInstruction.settings.options)
            options = JSON.stringify(this._navigationInstruction.settings.options);
        if (!options)
            options = localStorage.getItem(key);
        if (options) {
            var optionsObj = JSON.parse(options);
            localStorage.setItem(key, options);
            return optionsObj;
        }
        return null;
    };
    InstantGame.prototype.setNavigationInfo = function (newItem) {
        var options = this.getOptions();
        var brandId = options && !newItem.updateBrandInstantGame ? options.brandId : null;
        newItem.navigationInfo = {
            isOpenedFromLotteryAdmin: options ? options.isOpenedFromLotteryAdmin : true,
            isOpenedFromBrandAdmin: options ? options.isOpenedFromBrandAdmin : null,
            brandId: newItem.updateBrandInstantGame ? newItem.updateBrandInstantGame.brandId : brandId,
            brandName: options ? options.brandName : null,
            brandLanguages: options ? options.brandLanguages : null,
            brandInstantGames: options ? options.brandInstantGames : null,
            brandDefaultCurrencyId: options ? options.brandDefaultCurrencyId : null,
            brandTemplateInternalName: options && options.brandTemplateInternalName ? options.brandTemplateInternalName : "",
            brandThemeInternalName: options && options.brandThemeInternalName ? options.brandThemeInternalName : "",
            redirectUrl: options && options.redirectUrl && !newItem.updateBrandInstantGame ? options.redirectUrl : "",
            isPromotion: options && options.isPromotion && !newItem.updateBrandInstantGame ? options.isPromotion : false,
        };
        if (newItem.updateBrandInstantGame && newItem.updateBrandInstantGame.redirectUrl) {
            newItem.navigationInfo.redirectUrl = newItem.updateBrandInstantGame.redirectUrl;
        }
        if (newItem.updateBrandInstantGame && newItem.updateBrandInstantGame.isPromotion)
            newItem.navigationInfo.isPromotion = newItem.updateBrandInstantGame.isPromotion;
    };
    InstantGame.prototype.initValidations = function (newItem) {
        var _this = this;
        this.rules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Name is required.")
            .ensure(function (x) { return x.insurerId; }).required().satisfies(function (x) { return x > 0; }).withMessage("Insurer is required.")
            .ensure(function (x) { return x.currencyId; }).required().withMessage("Currency is required.")
            .ensure(function (x) { return x.rngUrl; }).required().withMessage("Rng url is required.")
            .ensure(function (x) { return x.instantGamesHostingTypeId; }).required().withMessage("Instant Game Hosting Type is required.")
            .ensure(function (x) { return x.playportUrl; }).satisfies(function (x) {
            var isvalid = !x && _this.item.instantGamesHostingTypeId == InstantGamesHostingTypesEnum.Playport;
            return !isvalid;
        }).withMessage("Playport url is required since 'Playport' was selected Instant Games Hosting type.")
            .ensure(function (x) { return x.externalGameId; }).satisfies(function (x) {
            var isvalid = !x && _this.item.instantGamesHostingTypeId == InstantGamesHostingTypesEnum.Playport;
            return !isvalid;
        }).withMessage("External Game Id is required since 'Playport' was selected Instant Games Hosting type.")
            .ensure(function (x) { return x.pricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).where(function (x) { return x.brand != null || x.operator != null; });
            var isValid = true;
            if (lotteryBrandPrices.toArray().length == 1) {
                lotteryBrandPrices.selectMany(function (y) { return y.lotteryBrandPrices; }).forEach(function (v) { if (v.price == null || v.price == 0)
                    isValid = false; });
            }
            return isValid;
        }).withMessage("Enter a valid ticket price for every range. Prices cannot be left empty or zero.")
            .ensure(function (x) { return x.instantGamePriceTiers; })
            .satisfies(function (x) {
            var isValid = true;
            if (_this.item.isWinningRangeRequired && _this.item.instantGamesHostingTypeId == InstantGamesHostingTypesEnum.Playport) {
                isValid = !Enumerable.from(x).any(function (x) { return (Number(x.winningRangeFrom) == 0) && (Number(x.winningRangeTo) == 0); });
            }
            return isValid;
        }).withMessage("Winning Range is Required, please enter winning Range From and Range To for all prize tiers")
            .ensure(function (x) { return x.pricingModels; }).satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).selectMany(function (x) { return x.lotteryBrandDiscounts; });
            var allNumberOfTriesNotEqualToZero = lotteryBrandPrices.all(function (x) { return x.numberOfDraws != 0; });
            return allNumberOfTriesNotEqualToZero;
        }).withMessage("Cannot have number of tries with the value 0 in ticket discounts.")
            .ensure(function (x) { return x.pricingModels; }).satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).selectMany(function (x) { return x.lotteryBrandDiscounts; });
            var checkAnyDuplicateValue = lotteryBrandPrices.groupBy(function (x) { return x.numberOfDraws; }).any(function (x) { return x.count() > 1; });
            return !checkAnyDuplicateValue; //checkAnyDuplicate ? false : true;
        }).withMessage("Cannot have duplicate number of tries in ticket discounts.")
            .ensure(function (x) { return x.pricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).where(function (x) { return x.brand != null || x.operator != null; });
            var isValid = true;
            if (lotteryBrandPrices.toArray().length == 1) {
                lotteryBrandPrices.selectMany(function (y) { return y.lotteryBrandPrices; }).forEach(function (v) { if (v.currencyId == null || v.currencyId == 0)
                    isValid = false; });
            }
            return isValid;
        }).withMessage("Currency field cannot be empty.")
            .ensure(function (x) { return x.pricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).where(function (x) { return x.brand != null || x.operator != null; });
            var isValid = true;
            if (lotteryBrandPrices.toArray().length == 1) {
                var brandPriceArray = lotteryBrandPrices.selectMany(function (y) { return y.lotteryBrandPrices; }).where(function (x) { return x.lotteryJackpotRangeId == null
                    && x.currencyId != 0; }).select(function (x) { return x.currencyId; }).toArray();
                if ((new Set(brandPriceArray)).size !== brandPriceArray.length) {
                    isValid = false;
                }
            }
            return isValid;
        }).withMessage("You cannot select same currency.Please check it.")
            .on(newItem)
            .rules;
        this.tierRules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Prize Tier name is required.")
            .ensure(function (x) { return x.insuranceTierName; }).required().withMessage("Insurance Name is required.")
            .ensure(function (x) { return x.internalName; }).required().withMessage("Internal Name is required.")
            .ensure(function (x) { return x.winningAmountText; }).required().withMessage("Winning Amount Text is required.")
            //.ensure<number>(x => x.odds).satisfies(x => x > 0).withMessage("Odds must be greater than 0.")
            .rules;
    };
    InstantGame.prototype.getPropertiesToSkip = function () {
        return ["navigationInfo"];
    };
    InstantGame.prototype.getSteps = function () {
        var options = this.getOptions();
        var showBrandTabs = this.tokenClient.isBrandAdmin();
        var stepList = [];
        stepList.push({
            title: this.i18N.tr('instant-game-basic-meta'),
            step: StepEnum.InstantGameBasicMeta,
            show: true,
            vm: this.instantGameBasicMeta,
            view: '../../app/admin/instant-game/steps/instant-game-basic-meta.html'
        });
        if (!options || options.isOpenedFromLotteryAdmin || options.isOpenedFromBrandAdmin) {
            stepList.push({
                title: this.i18N.tr('ticket-lines'),
                step: StepEnum.InstantGameTickets,
                show: true,
                vm: this.instantGameTickets,
                view: '../../app/admin/instant-game/steps/instant-game-tickets.html'
            });
            stepList.push({
                title: this.i18N.tr('change-log'),
                step: StepEnum.InstantGameChangeLog,
                vm: this.instantGameChangeLog,
                show: this.userClaimsService.hasPermission(BaseClaims.ViewAuditHistory),
                view: '../../app/admin/instant-game/steps/instant-game-changelog.html'
            });
        }
        if (!options || options.isOpenedFromLotteryAdmin) {
            stepList.push({
                title: this.i18N.tr('instant-game-price-tiers'),
                step: StepEnum.InstantGamePriceTiers,
                vm: this.instantGamePriceTiers,
                show: !showBrandTabs,
                view: '../../app/admin/instant-game/steps/instant-game-price-tiers.html'
            });
        }
        else {
            stepList.push({
                title: this.i18N.tr('instant-game-tickets-prices'),
                step: StepEnum.InstantGameTicketPrices,
                vm: this.instantGameTicketPrices,
                show: true,
                view: '../../app/admin/instant-game/steps/instant-game-ticket-prices.html'
            });
            stepList.push({
                title: this.i18N.tr('instant-game-tickets-discounts'),
                step: StepEnum.InstantGameTicketDiscounts,
                vm: this.instantGameTicketDiscounts,
                show: true,
                view: '../../app/admin/instant-game/steps/instant-game-ticket-discounts.html'
            });
        }
        return stepList;
    };
    // Inherited
    InstantGame.prototype.getItem = function (id) {
        var options = this.getOptions();
        var request = {
            id: id,
            brandId: options ? options.brandId : null,
            operatorId: options ? options.operatorId : null,
        };
        return this.instantGameClientService.getInstantGameForAdmin(request);
    };
    InstantGame.prototype.getItemId = function () {
        return this.item.instantGameId;
    };
    InstantGame.prototype.getEntityType = function () {
        return EntityTypes.InstantGame;
    };
    InstantGame.prototype.saveItem = function (id, changes) {
        var options = this.getOptions();
        var request = {
            id: id, changes: changes,
            // only pass the brandId | operatorId if the navigation info is not null i.e. if we ar ein a Manage Brand  | Manage Operator
            brandId: options ? options.brandId : this.item.navigationInfo ? this.item.navigationInfo.brandId : null,
            operatorId: options ? options.operatorId : this.item.navigationInfo ? this.item.navigationInfo.operatorId : null,
        };
        return this.instantGameClientService.save(request);
    };
    InstantGame.prototype.handleUpdateCompleted = function (response, isNew) {
        if (response && response.instantGameNameAlreadyExists) {
            this.notificationService.show("Validation Error!", "Instant Game name must be unique.", NotificationType.Error);
        }
        else {
            _super.prototype.handleUpdateCompleted.call(this, response, isNew);
        }
    };
    InstantGame.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageInstantGame;
    };
    InstantGame.prototype.initializeItemForCreate = function () {
        return this.defaultInstantGame;
    };
    InstantGame.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListInstantGames;
    };
    InstantGame.prototype.deleteInstantGame = function () {
        var _this = this;
        require("../dialogs/delete-modal"); // this is to show delete modal dialog
        if (this.item.instantGameId) {
            this.dialogClientService.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
                delete: function () { return new Promise(function (resolve, reject) {
                    _this.instantGameClientService.delete({ instantGameId: _this.item.instantGameId }).then(function (response) {
                        if (response.deleteSuccessfully) {
                            _this.notificationService.show(_this.i18N.tr("instant-game-delete-notification-title"), _this.i18N.tr("instant-game-delete-notification-message-success"), NotificationType.Success);
                            _this.router.navigateToRoute(_this.getListRoute());
                            resolve();
                        }
                        else {
                            _this.notificationService.show(_this.i18N.tr("instant-game-delete-notification-title"), _this.i18N.tr("instant-game-delete-notification-message-error"), NotificationType.Error);
                            reject();
                        }
                    }).catch(function () {
                        _this.notificationService.show(_this.i18N.tr("instant-game-delete-notification-title"), _this.i18N.tr("instant-game-delete-notification-message-error"), NotificationType.Error);
                        reject();
                    });
                }); }
            });
        }
    };
    InstantGame.prototype.beforeSave = function (skipValidation, resolve) {
        var _this = this;
        Promise.all([
            this.controller.validate({ object: this.item, rules: this.rules }),
        ].concat(Enumerable.from(this.item.instantGamePriceTiers).select(function (a) { return _this.controller.validate({ object: a, rules: _this.tierRules }); }).toArray())).then(function (result) {
            resolve(Enumerable.from(result).all(function (x) { return x.valid; }), _this.controller.errors.map(function (x) { return x.message; }).join("\n"));
        });
    };
    InstantGame.prototype.getSaveConfirmation = function () {
        return this.getRenameAwareSaveConfirmation();
    };
    InstantGame = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ValidationControllerFactory,
            DialogClientService,
            TokenClient,
            Router,
            BindingEngine,
            NotificationClientService,
            EventAggregator,
            InstantGameClientService,
            I18N,
            InstantGameBasicMeta,
            InstantGamePriceTiers,
            UserClaimsService,
            InstantGameTicketPrices,
            InstantGameTicketDiscounts,
            InstantGameChangeLog,
            BrandClientService,
            InstantGameTicketLines,
            InstantGameTickets])
    ], InstantGame);
    return InstantGame;
}(BaseEntity));
export { InstantGame };
